// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1_hF1","disabled":"FileBtn_disabled__1-xrh","warn":"FileBtn_warn__3cNCi","fade":"FileBtn_fade__2nYUm"};